import { ref } from "vue";
export default {
  name: "Footer",
  setup: function setup() {
    var isShowDouYin = ref(false); //是否展示抖音二维码

    var isShowWeibo = ref(false); //是否展示微博二维码

    var isShowBzhan = ref(false); //是否展示B站二维码
    //鼠标移入展示微信二维码

    function showQR(id) {
      if (id == "android") {
        isShowDouYin.value = true;
      } else if (id == "apple") {
        isShowWeibo.value = true;
      } else {
        isShowBzhan.value = true;
      }
    } //鼠标离开隐藏微信二维码


    function hiddenQR() {
      isShowDouYin.value = false;
      isShowWeibo.value = false;
      isShowBzhan.value = false;
    } //回到顶部


    function toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

    function handleDownload(e) {
      if (e == '0') {
        this.downloadUrl = 'https://download.xuehome.com.cn/app/android/app-release.apk';
      } else {
        this.downloadUrl = '';
      }

      if (!this.downloadUrl) {
        console.warn('下载链接不能为空');
        return;
      }

      try {
        if (this.newWindow) {
          // 在新窗口打开下载链接
          window.open(this.downloadUrl, '_blank');
        } else {
          // 在当前窗口跳转下载链接
          window.location.href = this.downloadUrl;
        }
      } catch (error) {
        console.error('下载失败:', error); // 可以在这里添加错误提示逻辑
      }
    }

    return {
      isShowDouYin: isShowDouYin,
      isShowWeibo: isShowWeibo,
      isShowBzhan: isShowBzhan,
      showQR: showQR,
      hiddenQR: hiddenQR,
      toTop: toTop,
      handleDownload: handleDownload
    };
  }
};